import { Lock } from "lucide-react";

import { Switch } from "@/components/ui/switch";

import type { RuntimeVar } from "./runtimeFlags";

const NONE = "—";

interface RuntimeVariableValueProps {
  entry?: RuntimeVar;
  wrap?: boolean;
}

export function RuntimeVariableValue({
  entry,
  wrap = false,
}: RuntimeVariableValueProps) {
  if (!entry) {
    return <span className="text-muted-foreground">{NONE}</span>;
  }
  if (entry.class === "secret") {
    return (
      <span className="flex items-center gap-1.5 text-muted-foreground">
        <Lock className="size-3.5" />
        <span className="text-xs">secret · {storeLabel(entry.store)}</span>
      </span>
    );
  }
  if (entry.class === "flag") {
    return (
      <span
        className="flex items-center gap-2"
        title="Read-only effective value from the selected AWS environment."
      >
        <Switch checked={entry.enabled === true} disabled aria-readonly />
        <span className="text-xs text-muted-foreground">
          {entry.enabled ? "on" : "off"}
        </span>
      </span>
    );
  }
  const value = entry.value ?? "";
  return value === "" ? (
    <span className="text-muted-foreground">{NONE}</span>
  ) : (
    <span
      className={
        wrap
          ? "whitespace-normal break-words font-mono text-xs [overflow-wrap:anywhere]"
          : "break-all font-mono text-xs"
      }
      title={value}
    >
      {wrap || value.length <= 140 ? value : `${value.slice(0, 140)}…`}
    </span>
  );
}

function storeLabel(store?: string): string {
  switch (store) {
    case "secretsmanager":
      return "Secrets Manager";
    case "ssm":
      return "SSM";
    case "plaintext-env":
      return "redacted plaintext";
    default:
      return "configured";
  }
}
